module.exports = __webpack_public_path__ + "img/happycarpeople.4deeacaa.jpg";